// import { createRoot } from 'react-dom/client';

// // styles
// import './index.scss';

// // project-imports
// import App from './App';
// import { ConfigProvider } from 'contexts/ConfigContext';

// import '@fontsource/open-sans/300.css';
// import '@fontsource/open-sans/400.css';
// import '@fontsource/open-sans/500.css';
// import '@fontsource/open-sans/600.css';

// const container = document.getElementById('root');
// const root = createRoot(container);

// // ==============================|| MAIN - REACT DOM RENDER ||============================== //

// root.render(
//   <ConfigProvider>
//     <App />
//   </ConfigProvider>
// );

import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';

// styles
import './index.scss';

import App from './App';
import { ConfigProvider } from './contexts/ConfigContext';
import AuthProvider from './context/AuthProvider';
import { swrFetcher } from './api/swrFetcher';

import 'temporal-polyfill/global';

import '@fontsource/open-sans/latin-300.css';
import '@fontsource/open-sans/latin-400.css';
import '@fontsource/open-sans/latin-500.css';
import '@fontsource/open-sans/latin-600.css';

const root = createRoot(document.getElementById('root'));

root.render(
  // <ConfigProvider>
  //   <AuthProvider>
  //     <SWRConfig
  //       value={{
  //         fetcher: swrFetcher,
  //         shouldRetryOnError: false,
  //         revalidateOnFocus: false,
  //         dedupingInterval: 1000
  //       }}
  //     >
  //       <App />
  //     </SWRConfig>
  //   </AuthProvider>
  // </ConfigProvider>
  <ConfigProvider>
    <SWRConfig
      value={{
        fetcher: swrFetcher,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        dedupingInterval: 1000
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </SWRConfig>
  </ConfigProvider>
);
